import { useState } from 'react'
import { Link, Menu, MenuItem, Tooltip } from '@mui/material'
import { sileo } from 'sileo'
import businessApi from '../../../../../../api/business.api'

const openDocument = document => window.open(document.downloadUrl, '_blank', 'noopener,noreferrer')

// La downloadUrl vence a las 12 horas: se pide en cada clic y no se guarda.
const LinkageDocumentsIcon = ({ row, businessId, children, renderTrigger }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(false)
  const count = Number(row?.cantidadDocumentos) || 0
  if (count <= 0 || row?.idOrigin == null || !businessId) return renderTrigger ? renderTrigger({}) : children ?? null

  const handleClick = async event => {
    event.stopPropagation()
    const rect = event.currentTarget.getBoundingClientRect()
    const position = { top: rect.bottom, left: rect.left }
    setLoading(true)
    try {
      const { data } = await businessApi.getBusinessDocuments(businessId, { comprobanteManualId: row.idOrigin })
      const rows = (Array.isArray(data) ? data : []).filter(document => document?.downloadUrl)
      if (rows.length === 0) throw new Error('La vinculación no tiene documentos disponibles')
      if (rows.length === 1) {
        openDocument(rows[0])
      } else {
        setDocuments(rows)
        setAnchorEl(position)
      }
    } catch (error) {
      console.error('[Vinculaciones] Error al obtener documentos', error)
      sileo.error({ title: 'Documentos', description: 'No se pudieron obtener los documentos de la vinculación.' })
    } finally {
      setLoading(false)
    }
  }

  const label = count === 1 ? '1 documento' : `${count} documentos`

  return (
    <>
      {renderTrigger ? renderTrigger({ onClick: handleClick, disabled: loading }) : <Tooltip title={label}>
        <Link
          component='button'
          type='button'
          aria-label={`Ver documentos (${label})`}
          aria-haspopup='menu'
          disabled={loading}
          onClick={handleClick}
          className='cursor-pointer disabled:opacity-50'
          sx={{ fontSize: 'inherit', fontFamily: 'inherit' }}
        >
          {children ?? row.numeroFolio ?? '-'}
        </Link>
      </Tooltip>}
      <Menu anchorReference='anchorPosition' anchorPosition={anchorEl ?? undefined} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {documents.map(document => (
          <MenuItem
            key={document.id}
            onClick={() => {
              setAnchorEl(null)
              openDocument(document)
            }}
          >
            {document.fileName ?? 'Documento adjunto'}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LinkageDocumentsIcon
